import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=59c22c3a&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59c22c3a')) {
      api.createRecord('59c22c3a', component.options)
    } else {
      api.reload('59c22c3a', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=59c22c3a&", function () {
      api.rerender('59c22c3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2pObP9khw6lOP/JS/offershelp.vue"
export default component.exports